import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 11,
			height: 11,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 6.5H13.5",
			stroke: "var(--table-icon-stroke, white)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 2.5V13.5",
			stroke: "var(--table-icon-stroke, white)",
			strokeWidth: 1.5
		})
	]
});
export default SvgTableFilled;
